export default __webpack_public_path__ + "maps-examples-building-extrusions-960-6a7cd01b9685202b153a4a1c2fa32f05.png";